<template>
    <div>
        <b-row class="pb-2">
            <b-col>
                <app-detalhe titulo="Condições de Pagamento" :xl="xl">
                        <strong>{{ item.nomeCondicaoPagamento }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Local de Faturamento" :xl="xl">
                        <strong>{{ item.nomeLocalFaturamento }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Nome do Fornecedor" :xl="xl">
                        <strong>{{ item.nomeFornecedor }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Vigência Inicio" :xl="xl">
                    <strong>{{ item.vigenciaInicio ?
                        $moment(item.vigenciaInicio).format(
                                    'DD/MM/YYYY'
                                )
                            : ''  
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="vigencia Fim" :xl="xl">
                    <strong>{{ item.vigenciaFim ?
                        $moment(item.vigenciaFim).format(
                                    'DD/MM/YYYY'
                                )
                            : ''  
                    }}</strong>
                </app-detalhe>
            </b-col>
        </b-row>    
    </div>
</template>

<script>        

export default {

    props: {
        item: {
            type: Object,
            default: () => {}
        },
    },
    
    data() {
        return {
            xl: 2,
        }
    },

    methods: {
    },

    created() {
    },
}

</script>

<style>

</style>